module.exports = __webpack_public_path__ + "img/pin.61a03d38.svg";